// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#order-excel-table[data-v-632a6d27] {\n  border: 1px solid black;\n  border-collapse: collapse;\n}\n#order-excel-table th[data-v-632a6d27],\n  #order-excel-table td[data-v-632a6d27] {\n    border: 1px solid black;\n    border-collapse: collapse;\n}\n", ""]);
// Exports
module.exports = exports;
